export default __webpack_public_path__ + "static/media/park_marker.9cb7a7dd.svg";